module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_5.32414ea4.pdf";